module.exports = {
  /**
   * 显示标题
   */
  title: 'srm 系统',

  /**
   * 显示右边设置
   */
  showSettings: false,

  /**
   * 是否显示多标签
   */
  tagsView: true,

  /**
   * 是否固定头部
   */
  fixedHeader: true,

  /**
   * 是否显示左边logo
   */
  sidebarLogo: true,

  /**
   * 请求头token名称
   */
  headerToken: {
    development:'srmh5DevToken',
    preproduction:"srmh5DevToken",
    production:"srmh5Token"
  },

  /**
   * 文件上传mqtt 场景值
   */
  mqttqTopic: {
    development:'dev/pub/quality/neibao/konggang/4L/cam/dateocr',
    preproduction:"dev/pub/quality/neibao/konggang/4L/cam/dateocr",
    production:"pub/quality/neibao/konggang/4L/cam/dateocr"
  },

  /**
   * 批量查询分隔符
   */
  batchDelimiter: '(enter)',

  /**
   * 	domain标识指定了哪些主机可以访问该Cookie的域名。
   *  如果设置为“.google.com”，则所有以“google.com”结尾的域名都可以访问该Cookie。
   *  注意第一个字符必须为“.”
   */
   domainName: {
    development: 'localhost',
    preproduction: '.xuanma.com',
    production: '.xuanma.com',
  },

  /**
   * 	authUrl 跳转的鉴权系统登录页url
   */
   authUrl: {
    development: 'http://localhost:9999/login',
    preproduction: 'http://dev.auth.xuanma.cn/login',
    production: 'https://auth.xuanma.cn/login',
  },

  /**
   * 登录后不跳转的到的路径
   */
  NoJumpUrlPath: [
    '/error/401',
    '/error/403',
    '/error/404',
    '/error/500'
  ],

  /**
   * 是否打印日志，开发环境和线上环境都可以开启
   * @type {string | array} 'production' | ['production', 'development']
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
